export const ScorecardExpiryNotificationAcknowledgement = 'ScorecardExpiryNotificationAcknowledgement/';

export const AcknowledgeExpiryNotification = ScorecardExpiryNotificationAcknowledgement + 'AcknowledgeExpiryNotification';
export const ShowExpiryModal = ScorecardExpiryNotificationAcknowledgement + 'ShowExpiryModal';
export const ShowRenewalModal = ScorecardExpiryNotificationAcknowledgement + 'ShowRenewalModal';